import api from "../../axios";
export const applyAdvanceToInvoice = (request) => {
  return new Promise((resolve, reject) => {
    api
      .post("/api/v1/advance-invoice/apply-to-invoice", request)
      .then((r) => resolve(r))
      .catch((e) => reject(e));
  });
};